import type { Network } from "../types";

export const reddit: Network = {
  name: "Reddit",
  shareUrl: "https://www.reddit.com/submit?url=[u]",
  args: {
    title: "&title=[t]",
  },
  icon: "/media/images/facebook-social-auth.svg",
  color: "#FF4500",
};
